export default __webpack_public_path__ + "alberta-contract-article-group.aeeae45a2a5d12f65f72.svg";